import React, { Component } from "react";
import DepartmentIndustryCards from "../component/DepartmentIndustryCards";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import Footer from "../../../components/common/Footer";

export default class VLSIIndustry extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner
          title="Electronics Engineering (VLSI Design & Technology)"
          image="banners/department-cse.jpg"
        />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Industry Interactions</h4>
                    </div>
                  </div>
                  <div className="ttm-service-description">
                    <p className="justify">
                      Presently there are 4 MOU's signed and associated with CSE
                      Department. Workshops and Webinars are conducted in every
                      academic years.
                      <a
                        className="ttm-btn"
                        style={{ paddingLeft: "10px" }}
                        href="https://docs.google.com/spreadsheets/d/1z5dv00JBkef7Yibt7oFCezojK0W-E53-8p2l3sUtUus/edit?usp=sharing"
                        target="_blank"
                      >
                        Industry Interactions Link
                      </a>
                      <a
                        className="ttm-btn"
                        style={{ paddingLeft: "10px" }}
                        href="https://drive.google.com/drive/folders/1FNeCAKJsxG5BcnvevlCsJmaKsL8oGr_0?usp=sharing"
                        target="_blank"
                      >
                        MOU Agreements Copy
                      </a>
                    </p>
                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h5> Internships With Industries</h5>
                      </div>
                    </div>
                    <p>
                      With the growing number of students opting for engineering
                      as a career over the past few decades, it has become
                      increasingly important to equip them with
                      industry-relevant skills that help them stand out and
                      excel in their chosen domains. Recognizing this critical
                      need, the All India Council for Technical Education
                      (AICTE) has mandated that engineering undergraduates
                      complete three internships, each spanning 4–8 weeks,
                      during the course of their academic program.
                    </p>

                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h5>Purpose and Objectives</h5>
                      </div>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          This initiative is designed to achieve several key
                          objectives
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Enhance students’ employability by providing hands-on
                          exposure to real-world industrial practices.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Bridge the gap between academic learning and industry
                          expectations.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Facilitate the development of technical, managerial,
                          and communication skills through experiential
                          learning.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Encourage innovation, problem-solving, and
                          adaptability, fostering readiness for future
                          challenges in a competitive job market.
                        </span>
                      </li>
                    </ul>

                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h5>Institutional Support and Implementation</h5>
                      </div>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To support this mandate, the institution has
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Established a dedicated Training and Placement Cell
                          (TPC) that coordinates with industries to identify and
                          facilitate internship opportunities.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Formed strategic partnerships and MoUs with companies,
                          startups, and research organizations.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Facilitate the development of technical, managerial,
                          and communication skills through experiential
                          learning.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Organized pre-internship training, including resume
                          building, communication skill development, and
                          orientation programs to prepare students for the
                          internship experience.
                        </span>
                      </li>
                    </ul>

                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h5>Internship Opportunities and Outcomes</h5>
                      </div>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Students undertake internships in diverse sectors such
                          as
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Core Engineering (Mechanical, Civil, Electrical,
                          Electronics)
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Artificial Intelligence, Machine Learning, and Data
                          Science
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          VLSI Design and Embedded Systems
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Startups and Incubation Centers
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Public Sector and Research Institutions (e.g., ISRO,
                          DRDO, HAL)
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Outcomes and benefits observed
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Improved placement opportunities and Pre-Placement
                          Offers (PPOs).
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Real-time exposure to industrial tools, software, and
                          workflow.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Contribution to live projects, technical
                          documentation, and problem-solving tasks.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Enhanced understanding of team dynamics, workplace
                          ethics, and project management
                        </span>
                      </li>
                    </ul>

                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h5>Assessment and Documentation</h5>
                      </div>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Each internship is documented through
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          A comprehensive internship report submitted by the
                          student.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Feedback from industry mentors.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Seminars/presentations evaluated by internal faculty
                          members using well-defined rubrics
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Internships carry academic credits as per university
                          norms and are tracked in the student's academic
                          record.
                        </span>
                      </li>
                    </ul>

                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h5>Why Internships with Industries is necessary?</h5>
                      </div>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To fixate the standards of technical institutions in
                          terms of delivering the objectives and quality
                          education.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To enhance employment opportunities for engineering
                          students by imparting required knowledge and skills.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To increase college placement percentage.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To increase the percentage of students participating
                          in summer internships.
                        </span>
                      </li>
                    </ul>
                    <DepartmentIndustryCards department="cse" />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="vlsi" />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
